import headerBg from '@/assets/images/active/mitu/special/head/header_bg1.png';
import headerBg2 from '@/assets/images/active/mitu/special/head/header_bg.png';
import officeBtn from '@/assets/images/active/mitu/special/head/offical.png';
import downloadBtn from '@/assets/images/active/mitu/special/head/download.png';
import loginBtn from '@/assets/images/active/mitu/special/head/login.png';
import accountBtn from '@/assets/images/active/travel/header/btn_07.png';
import activeBtn from '@/assets/images/active/travel/header/btn_09.png';
import logoutBtn from '@/assets/images/active/mitu/special/head/logoutBtn.png';
import loadBtn from '@/assets/images/active/travel/header/btn_10.png';

export const headerConfig = {
  not_logged_in: {
    background_image: headerBg2,
    style: 'height:142px'
  },
  logged_in: {
    background_image: headerBg,
    main_title_color: '#5c2d2b',
    sub_title_color: '#5c2d2b',
    tips_color: '#5c2d2b',
    game_name: '迷途之光'
  },
  operation_btn: {
    office_website: {
      width: '',
      height: '',
      background_image: '',
      img: downloadBtn,
      style: 'top: 0.2rem',
      link: 'https://mtzg.qingcijoy.com/'
    },
    login: {
      width: '',
      height: '',
      background_image: '',
      img: loginBtn,
      style: 'top: 0.2rem',
    },
    change_account: {
      width: '',
      height: '',
      background_image: '',
      img: accountBtn,
      style: 'top: 0.2rem'
    },
    join_active: {
      width: '',
      height: '',
      background_image: '',
      img: activeBtn,
      style: 'top: 0.2rem',
      link: 'https://qcg.ink/XrLOO4'
    },
    logout: {
      width: '',
      height: '',
      img: logoutBtn,
      style: 'top: 0.2rem'
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/mitu/special/headerConfig.js